import HardwareSerializer from 'eflex/serializers/hardware';

export default class NodeRedSerializer extends HardwareSerializer {}
